import type { ResolvedEntry, SearchResult } from "./types";

const DIACRITIC_REGEX = /[̀-ͯ]/g;

/**
 * Lowercase + strip diacritics so "đặt lịch" matches "dat lich".
 * Required for accurate matching in VI/CS/DE/PL locales.
 */
export function normalize(input: string): string {
  return input.normalize("NFD").replace(DIACRITIC_REGEX, "").toLowerCase().trim();
}

const SECTION_BOOST = 10;

function score(query: string, entry: ResolvedEntry): number {
  const label = normalize(entry.label);
  const description = normalize(entry.description);
  const keywords = entry.keywords.map(normalize);
  const boost = entry.kind === "section" ? SECTION_BOOST : 0;

  if (label === query) return 100 + boost;
  if (label.startsWith(query)) return 80 + boost;
  if (keywords.includes(query)) return 70 + boost;
  if (label.includes(query)) return 60 + boost;
  if (keywords.some((keyword) => keyword.includes(query))) return 40 + boost;
  if (description.includes(query)) return 25 + boost;
  return 0;
}

export function searchEntries(query: string, entries: readonly ResolvedEntry[]): SearchResult[] {
  const normalized = normalize(query);
  if (normalized.length === 0) return [];

  const results: SearchResult[] = [];
  for (const entry of entries) {
    const matchScore = score(normalized, entry);
    if (matchScore > 0) {
      results.push({ ...entry, score: matchScore });
    }
  }
  return results.sort((a, b) => b.score - a.score);
}
